import { withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5073644a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "alert",
  class: "oxd-color-picker"
}
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_label = _resolveComponent("oxd-label")!
  const _component_oxd_input = _resolveComponent("oxd-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "oxd-color-picker-indicator",
      style: _normalizeStyle(_ctx.indicatorStyles),
      onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.captureOn && _ctx.captureOn(...args)), ["prevent"])),
      onTouchstart: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.captureOn && _ctx.captureOn(...args)), ["prevent"]))
    }, null, 36),
    _createElementVNode("canvas", {
      ref: "colorPalette",
      width: "228",
      height: "228",
      class: "oxd-color-picker-palette",
      onMousemove: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pickColor && _ctx.pickColor(...args)), ["prevent"])),
      onTouchmove: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pickColor && _ctx.pickColor(...args)), ["prevent"])),
      onMousedown: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.captureOn && _ctx.captureOn(...args)), ["prevent"])),
      onTouchstart: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.captureOn && _ctx.captureOn(...args)), ["prevent"]))
    }, null, 544),
    _createElementVNode("input", {
      value: _ctx.hue,
      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onHueChange && _ctx.onHueChange(...args))),
      class: "oxd-color-picker-range",
      type: "range",
      max: "359"
    }, null, 40, _hoisted_2),
    _createVNode(_component_oxd_label, {
      label: _ctx.t('general.hex', 'HEX'),
      class: "oxd-color-picker-label"
    }, null, 8, ["label"]),
    _createVNode(_component_oxd_input, {
      value: _ctx.modelValue,
      "onUpdate:modelValue": _ctx.onHexInput
    }, null, 8, ["value", "onUpdate:modelValue"])
  ]))
}